import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/group`;
const token = localStorage.getItem("token");

/// GET
// Fonction pour récupérer tous les groupes
export const getGroups = async () => {
  try {
    const response = await axios.get(`${apiUrl}/allgroups`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des groupes:", error);
  }
};

export const getAllGroupsWithDetails = async () => {
  try {
    const response = await axios.get(`${apiUrl}/groups-details`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des groupes avec détails:", error);
  }
};

// Fonction pour compter le nombre de groupes
export const countGroups = async () => {
  try {
    const response = await axios.get(`${apiUrl}/countgroups`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du comptage des groupes:", error);
  }
};

// Fonction pour récupérer un groupe par son id
export const getGroupById = async (groupId) => {
  try {
    const response = await axios.get(`${apiUrl}/group/${groupId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement du groupe:", error);
  }
};

// Fonction pour obtenir les groupes d'un dojo par son id
export const getGroupsByDojo = async (dojoId) => {
  try {
    if (!dojoId) {
      console.error("❌ Erreur : dojoId est undefined !");
      return [];
    }

    const url = `${apiUrl}/dojo/${dojoId}`;
    console.log(`🔹 Envoi de la requête GET : ${url}`);

    const response = await axios.get(url);

    // Vérifier si la réponse contient bien un tableau
    if (Array.isArray(response.data)) {
      console.log("✅ Réponse de l'API Groupes :", response.data);
      return response.data;
    } else {
      console.error("❌ Erreur : La réponse API n'est pas un tableau !");
      return [];
    }
  } catch (error) {
    console.error("❌ Erreur lors du chargement des groupes du dojo :", error);
    return [];
  }
};

// Fonction pour obtenir les groupes d'un enseignant par son id
export const getGroupsByTeacher = async (teacherId) => {
  try {
    const response = await axios.get(`${apiUrl}/teacher/${teacherId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des groupes de l'enseignant:",
      error
    );
  }
};

// Compter le nombre d'adhérents par groupe
export const countMembersByGroup = async (groupId) => {
  try {
    const response = await axios.get(`${apiUrl}/groupmembers/${groupId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du comptage des membres du groupe:", error);
  }
};

// Fonction pour récupérer les groupes d'un club par son id
export const getGroupsByClub = async (clubId) => {
  try {
    const response = await axios.get(`${apiUrl}/club/${clubId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des groupes du club:", error);
  }
};

/// POST
// Fonction pour créer un groupe
export const createGroup = async (groupData) => {
  try {
    await axios.post(`${apiUrl}/creategroup`, groupData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Erreur lors de la création du groupe:", error);
  }
};

/// PUT
// Fonction pour mettre à jour un groupe
export const updateGroup = async (groupId, groupData) => {
  try {
    await axios.put(`${apiUrl}/updategroup/${groupId}`, groupData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Erreur lors de la mise à jour du groupe:", error);
  }
};

/// DELETE
// Fonction pour supprimer un groupe
export const deleteGroup = async (groupId) => {
  try {
    await axios.delete(`${apiUrl}/deletegroup/${groupId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Erreur lors de la suppression du groupe:", error);
  }
};
